"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWeWorkLeadMetadataFromCookies = getWeWorkLeadMetadataFromCookies;

var _getCookiesHash = require("./getCookiesHash");

var GOOGLE_ANALYTICS_VERSION_REGEX = /^GA[0-9]*\.[0-9]*\./;
var ERROR_MSG = 'Error attempting to parse cookie';
var GOOGLE_ANALYTICS_KEYS = ['gclsrc', 'gclid', 'dclid'];
/**
 * Grabs WeWork specific metadata from cookies and builds object
 * @return {Object}
 */

function getWeWorkLeadMetadataFromCookies() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$heapAppID = _ref.heapAppID,
      heapAppID = _ref$heapAppID === void 0 ? window.heap ? window.heap.appid : null : _ref$heapAppID;

  var cookies = (0, _getCookiesHash.getCookies)();
  if (!cookies) return undefined;
  var metadata = {};
  var googleAnalytics = {};

  if (cookies['_ga']) {
    metadata.google_id = cookies['_ga'].replace(GOOGLE_ANALYTICS_VERSION_REGEX, '');
  }

  try {
    if (cookies['we_search_params']) {
      var searchParams = JSON.parse(decodeURIComponent(cookies['we_search_params']));
      Object.keys(searchParams).forEach(function (key) {
        var value = searchParams[key];

        if (GOOGLE_ANALYTICS_KEYS.includes(key)) {
          googleAnalytics[key] = value;
        } else {
          metadata[key] = value;
        }
      });
    }
  } catch (error) {
    console.warn(ERROR_MSG, 'we_search_params', error);
  }

  try {
    if (cookies["_hp2_id.".concat(heapAppID)]) {
      var heapAttrs = JSON.parse(decodeURIComponent(cookies["_hp2_id.".concat(heapAppID)]));
      metadata.heap_session_id = heapAttrs.sessionId;
    }
  } catch (error) {
    console.warn(ERROR_MSG, "_hp2_id.".concat(heapAppID), error);
  }

  if (cookies['we_referring_domain']) {
    metadata.first_referring_domain = decodeURIComponent(cookies['we_referring_domain']);
  }

  if (Object.keys(googleAnalytics).length > 0) {
    metadata.google_analytics = googleAnalytics;
  }

  return metadata;
}